<template>
  <div v-if="reportAccess()">
    <!-- =====================johnny test start=================================== -->
    <div class="caption-label"><span class="mr-2">{{ function_name }} </span></div>
    <div class="row">
      <div class="col">
        <div class="row">

          <div class="col-2">
          <div class="label mt-2">Site:</div>
          <b-form-select v-model="GRO" :options="GRO_options"
            label="Select GRO Site:" @change="onChangeGRO(GRO)"></b-form-select>
          </div>
          <div class="col-2">
            <div class="label mt-2">Model:</div>
            <b-form-select v-model="model" :options="model_options"
              label="Select Model:" @change="onChangeModel(model)"></b-form-select>
          </div>
          <div class="col-2">
            <div class="label mt-2">GTC Owner:</div>
            <b-form-select v-model="GTC_owner" :options="GTC_owner_options"
              label="Select GTC Owner:" @change="onChangeGTC_owner(GTC_owner)"></b-form-select>
          </div>

          <div class="col-4">
            <div class="label mt-2">Date Range:</div>
            <div class="d-flex">
              <input type="text" class="form-control" v-model="date_from" v-datepicker:to="date_to" />
              <span class="font-weight-bold align-self-center"> ～ </span>
              <input type="text" class="form-control" v-model="date_to" v-datepicker:from="date_from" />
            </div>
          </div>

          <div class="col-6" style="padding-top: 25px;">
            <b-button @click="getDetailPage() " variant="primary" v-b-tooltip.hover title="Download Detail Report" size="lg" style="margin-right:10px ;">Detail</b-button>
            <b-button @click="getSummaryPage() " variant="primary" v-b-tooltip.hover title="Download Summary Report" size="lg" style="margin-right:10px ;">Summary</b-button>
            <b-button @click="getShipmentPage() " variant="primary" v-b-tooltip.hover title="Download Shipment Report" size="lg" style="margin-right:10px ;">Shipment</b-button>
          </div>
        </div>
      </div>
    </div>
    <!-- =====================johnny test end===================================== -->
  </div>
  <div v-else>
    <p> You don't have enough permission to access this page!</p>
  </div>
</template>

<script>
  import * as moment from 'moment/moment';
  export default {
    name: 'dashboard',
    data() {
      return {
        function_name: 'Custom Level Report',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        keywords: '',
        authUrl: '',
        frontendUrl: '',
        thisPageLoadingCnt: 0,
        userInfo: '',
        userEmail: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        date_from: moment().subtract(3, 'months').format('YYYY-MMM-DD'),
        date_to: moment().format('YYYY-MMM-DD'),
        fileName: '',
        downLoadSuccess: '',

        // ================johnny start====================
        GRO: '',
        GROText: '',
        GRO_options_default: '',
        GRO_options: [{ value: '', text: 'ALL' }],

        model_options: [],
        model: '',
        modelText:'',
        model_options_default:'',

        GTC_owner_options: [],
        GTC_owner: '',
        GTC_ownerText: '',
        GTC_owner_options_default:'',
        // ===============johnny end=======================

        ftieId: '',
        partNumber: '',
        optyName: '', //PM Stryker - TACOM - T800s Spiral 1 - 2020
        customizationPartNumber: '',
        customizationPartNumberSingle: '',
        shippingPnSelection: '',

        already_first_search_flag: false,
        fields: [
            // =====================================johnny start============================
          { key: 'gtc_owner', label: 'GTC Owner', thClass: 'align-middle', sortable: true },
            // =====================================johnny end==============================
          {
            key: 'ftie_id', label: 'FTIE ID', thClass: 'align-middle', sortable: true,
            tdStyle: { 'rowspan': "3" },
          },
          { key: 'sfdc_opty_name', label: 'Salesforce Opportunity', thClass: 'align-middle', sortable: true },
          { key: 'customization_shipping_pn', label: 'Shipping P/N', thClass: 'align-middle', sortable: true },
          { key: 'pn', label: 'Unique Compo P/N', thClass: 'align-middle', sortable: true },
          { key: 'pn_description', label: 'Unique Compo P/N Description', thClass: 'align-middle', sortable: false },
          { key: 'project_info.PROJECT_NAME', label: 'Project Name', thClass: 'align-middle', sortable: true },
          { key: 'project_info.PROJECT_CODE', label: 'Project Code', thClass: 'align-middle', sortable: true },
          { key: 'project_info.PRODUCT_CODE', label: 'Product Code', thClass: 'align-middle', sortable: true },
          {
            key: 'inventory', label: 'Inventory Qty', thClass: 'align-middle', tdClass: '',
            tdStyle: { 'min-width': '47rem', 'rowspan': "3" },
            sortable: true, sortByFormatted: true,
            formatter: (value, key, item) => {
              return item.inventory_qty_total
            }
          },
          {
            key: 'po_info', label: 'PO Qty', thClass: 'align-middle', tdClass: '',
            tdStyle: { 'min-width': '47rem', 'rowspan': "3" },
            sortable: true, sortByFormatted: true,
          },
          {
            key: 'pr_info', label: 'PR Qty', thClass: 'align-middle', tdClass: '',
            tdStyle: { 'min-width': '47rem', 'rowspan': "3" },
            sortable: true, sortByFormatted: true,
          }
        ],
        inventoryFields: [
          { key: 'SUBINVENTORY_CODE', label: 'Sub-inventory Code', thClass: 'align-middle', sortable: true },
          { key: 'SUBINVENTORY_NAME', label: 'Sub-inventory Name', thClass: 'align-middle', sortable: true },
          { key: 'INVENTORY_QTY', label: 'Qty', thClass: 'align-middle', sortable: true },
        ],
        poFields: [
          { key: 'po_total_qty', label: 'PO Qty', thClass: 'align-middle', sortable: true },
          { key: 'po_detail', label: 'PO Detail', thClass: 'align-middle', sortable: true },
        ],

        prFields: [
          { key: 'pr_total_qty', label: 'PR Qty', thClass: 'align-middle', sortable: true },
          { key: 'pr_detail', label: 'PR Detail', thClass: 'align-middle', sortable: true },
        ],

        inventoryObjToShow: {
          inventoryItems: [],
          poItems: '',
          prItems: '',
          pn: '',
          pnDescription: '',
          projectName: '',
          projectCode: '',
          productCode: '',
        },

        searchedData: [],
        searchedDataAll: [],
        mergedDataframe: '',
        login_user_name: '',
        searching: false,
        pageDisabled: false,
        pageLimit: 10,
        perPage: 10,
        currentPage: 1,
        nreTotalCount: '',
      }
    },
    created() {
      let self = this;

    },
    computed: {
      rows() {
        return this.nreTotalCount
        //return this.searchedData.length
      },
      date_from_computed() {
        let str = moment(this.date_from, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      date_to_computed() {
        let str = moment(this.date_to, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      }
    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.thisPageLoadingCnt = 0;
      if (this.$route.params.keywords){
        this.keywords = this.$route.params.keywords;
        this.date_from = '';
        this.date_to = '';
        //this.searchInventory();
      }
    },
    methods: {
      reportAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        if ((user_site && _.indexOf(user_site, 'Getac') > -1) && (
          (user_roles && _.indexOf(user_roles, 'Admin') > -1)
          || (user_functions && _.indexOf(user_functions, 'ES PM Leader') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM') > -1)
          || (user_roles && _.indexOf(user_roles, 'HQ_ES') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1)
        )
        ) {
          console.log("Access to report!");
          return true
        }
        return false;
      },
      // =========================================johnny test start================================================
      onChangeGRO(GRO) {
        let groText = GRO;
        this.GRO = GRO
        if('' === GRO){
          groText = '---Select ALL---';
        }
        else {
          this.groText = '';
        }
      },
      onChangeModel(model) {
        let modelText = model;
        this.model = model
        if('' === model){
          modelText = '---Select All---';
        }
        else {
          this.modelText = '';
        }
      },
      onChangeGTC_owner(GTC_owner) {
        let GTC_ownerText = GTC_owner;
        this.GTC_owner = GTC_owner;
        if('' === GTC_owner) {
          GTC_ownerText = this.GTC_owner_options[0];
        }
        else{
          this.GTC_ownerText = '';
        }
      },

      getDetailPage() {
        let self = this;
        let url = self.$root.baseUrl + '/custom-level-report/unique_component/detail/';
        console.log('####getPage######');
        var i;

        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();

        let request_data = {
          GRO: self.GRO,
          model: self.model,
          GTC_owner: self.GTC_owner,
          date_from: self.date_from,
          date_to: self.date_to
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        let selection = [];
        if (self.table_show == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((response) => {
            var res = response.data;
            console.log("hello")
            //console.log(res);

            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = 'Detail_custom_level_report_' + this.login_user_name + '.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (response.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((response) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(response.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.table_show = true;
            if (self.table_show == true) {
              eventHub.$emit('loading', false);
            }
            self.searchedData = searchedData
            self.selection = selection;
            var i;
            if (searchedData.length == 0) {
              self.table_show = false;
            }
          })
      },
      getSummaryPage() {
        let self = this;
        let url = self.$root.baseUrl + '/custom-level-report/unique_component/summary/';
        console.log('####getPage######');
        var i;

        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();

        let request_data = {
          GRO: self.GRO,
          model: self.model,
          GTC_owner: self.GTC_owner,
          date_from: self.date_from,
          date_to: self.date_to
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        let selection = [];
        if (self.table_show == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((response) => {
            var res = response.data;
            console.log("hello")
            //console.log(res);

            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = 'Summary_custom_level_report_' + this.login_user_name + '.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.table_show = true;
            if (self.table_show == true) {
              eventHub.$emit('loading', false);
            }
            self.searchedData = searchedData
            self.selection = selection;
            var i;
            if (searchedData.length == 0) {
              self.table_show = false;
            }
          })
      },

      getShipmentPage() {
        let self = this;
        let url = self.$root.baseUrl + '/custom-level-report/unique_component/shipment/';
        console.log('####getPage######');
        var i;

        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();

        let request_data = {
          GRO: self.GRO,
          model: self.model,
          GTC_owner: self.GTC_owner,
          date_from: self.date_from,
          date_to: self.date_to
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        let selection = [];
        if (self.table_show == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((response) => {
            var res = response.data;
            console.log("hello")
            //console.log(res);

            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = 'Shipment_custom_level_report_' + this.login_user_name + '.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.table_show = true;
            if (self.table_show == true) {
              eventHub.$emit('loading', false);
            }
            self.searchedData = searchedData
            self.selection = selection;
            var i;
            if (searchedData.length == 0) {
              self.table_show = false;
            }

          })
      },
      // =========================================johnny test end==================================================


      // =======================================johnny test start================================================
      onChangeRsmDirector(GRO) {
        let groText = GRO;
        if ('' === GRO) {
          groText = 'ALL';
        }
        var options = this.$session.get('options');
        let indexStr = GRO;
        let rsmOptions = _.get(this.rsmSelectionDic, indexStr, ['']);
        let directorOptions = _.get(this.directorSelectionDic, indexStr, ['']);

        /* Region: build multi options for RSM, Directors */
        var directorMultiOptionList = new Array();
        for (var i = 0; i < directorOptions.length; i++) {
          directorMultiOptionList.push({ value: directorOptions[i], text: directorOptions[i] })
        }
        this.directorOptionList = directorMultiOptionList;

        /* Set Default Value for sales_director */
        if (directorOptions.length > 0) {
          this.sales_director = new Array();
          this.sales_director.push({ value: directorOptions[0], text: directorOptions[0] });
        }
        else {
          this.sales_director = '';
        }
        var rsmMultiOptionList = new Array();
        for (var i = 0; i < rsmOptions.length; i++) {
          rsmMultiOptionList.push({ value: rsmOptions[i], text: rsmOptions[i] })
        }
        this.rsmOptionList = rsmMultiOptionList;
        /* Set Default Value for region_sales_manager */
        if (rsmOptions.length === 0) {
          this.region_sales_manager = '';
        }
      },
        // =======================================johnny test end==================================================

      onChangeShippingPn(customizationPartNumber) {
        if (customizationPartNumber.length > 0) {
          this.customizationPartNumberSingle = '';
        }
      },

      showDetailData(dataItem, pn) {
        let self = this;
        let inventoryInfoList = dataItem.inventory_info_list
        self.inventoryObjToShow = {
          inventoryItems: JSON.parse(JSON.stringify(inventoryInfoList)),
          pn: pn,
          projectName: dataItem.project_info.PROJECT_NAME,
          projectCode: dataItem.project_info.PROJECT_CODE,
          productCode: dataItem.project_info.PRODUCT_CODE,
          poItems: dataItem.po_info,
          prItems: dataItem.pr_info,
        };
        console.log("inventoryObjToShow::");
        console.log(self.inventoryObjToShow);
      },

      zeroInventoryData(dataItem, pn) {
        let self = this;
        self.inventoryObjToShow = {
          pn: pn,
        };
        console.log("zeroInventoryData::");
        console.log(self.zeroInventoryData);
      },

      tooltipTitle(data, stage_index) {
        let self = this;
        var signing_stage = data.item.signing_stages[stage_index];
        return _.trim(self.stageTip[stage_index] + ' ' + _.trim(_.get(signing_stage, 'status_name', '')))
      },
      tooltipReason(data) {
        let self = this;
        return _.trim(_.get(data.item, 'reject_reason', ''))
      },

      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location = this.authUrl + 'Auth/SignOut' + '?redirect_uri=' + encodeURIComponent(this.frontendUrl + 'azure-login');
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);

        this.login_user_name = user_name;
        this.userEmail = user_email;
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;

//    ========================================GRO site toggle list start===========================================
        var gro_option_new = new Array();
        for (var i = 0; i < options.gro_opt_val_list.length; i++) {
            gro_option_new.push({ value: options.gro_opt_val_list[i], text: options.gro_opt_text_list[i] })
        }
        gro_option_new[0].text = '---Select ALL---'
        this.GRO_options = gro_option_new;
        this.GRO_options_default = gro_option_new[0];
        this.GRO = gro_option_new[0].value;
        this.GROText = gro_option_new[0].text;

//    ========================================GRO site toggle list end===========================================


// =======================================Model toggle list start============================================
        var model_option_new = new Array();
        var model_option_sort = new Array();

        model_option_new.push({ value: "", text: '---Select ALL---'})

        for (var i = 0; i < options.model_list.length; i++) {
            model_option_sort.push(options.model_list[i] );
        }
        model_option_sort = model_option_sort.sort()
        for (var i = 0; i < model_option_sort.length; i++) {
            model_option_new.push({ value: model_option_sort[i], text: model_option_sort[i] });
        }

        this.model_options = model_option_new;
        this.model_options_default = model_option_new[0];
        this.model = model_option_new[0].value;
        this.modelText = model_option_new[0].text;
// =======================================Model toggle list end==============================================

// =========================================GTC owner list start=================================================
        var gtc_owner_option_new = new Array();
        gtc_owner_option_new.push({ value: "", text: '---Select ALL---'})
        for (var i = 1; i < options.gtc_owner_opt_list.length; i++) {
            gtc_owner_option_new.push({ value: options.gtc_owner_opt_list[i], text: options.gtc_owner_opt_list[i] })
        }

        this.GTC_owner_options = gtc_owner_option_new;
        this.GTC_owner_options_default = gtc_owner_option_new[0];
        this.GTC_owner = gtc_owner_option_new[0].value;
        this.GTC_ownerText = gtc_owner_option_new[0].text;
      },

// =========================================GTC owner list end===================================================


      // TODO: NEW
      searchInventory() {
        if (this.thisPageLoadingCnt == 0) {
          this.already_first_search_flag = false;
          this.thisPageLoadingCnt = this.thisPageLoadingCnt + 1;
        }
        this.currentPage = 1;
        this.getInventory();
      },
      pageChange(page) {
        this.currentPage = page;
        if (this.searchedDataAll && this.searchedDataAll.length > 0 && this.searchedDataAll !== '' && this.nreTotalCount !== null && this.nreTotalCount > 0) {
          this.buildDataIndexbyPage();
        }
        else {
          this.getInventory(); // api call
        }
      },
      perPageChange() {
        this.currentPage = 1;
        if (this.searchedDataAll && this.searchedDataAll.length > 0 && this.searchedDataAll !== '' && this.nreTotalCount !== null && this.nreTotalCount > 0) {
          this.buildDataIndexbyPage();
        }
        else {
          this.getInventory(); // api call
        }
      },

      // TODO: NEW- DOWNLOAD
      reportDownload() {
        let self = this;
        let url = self.$root.baseUrl + '/johnny/unique_component/download/';
        console.log('####report - download######');
        let ftieList = [];
        if (self.ftieId !== '') {
          ftieList.push(self.ftieId);
        }

        let partNumberList = [];
        if (self.partNumber !== '') {
          partNumberList.push(self.partNumber);
        }

        let customizationShippingPnSelected = [];
        if (self.customizationPartNumber.length == 0) {
          customizationShippingPnSelected = '';
        } else {
          for (i = 0; i < self.customizationPartNumber.length; i++) {
            customizationShippingPnSelected.push(self.customizationPartNumber[i]['value'])
          }
        }

        let optyList = [];
        if (self.optyName !== '') {
          optyList.push(self.optyName);
        }

        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();
        let request_data = {
          part_number: partNumberList,
          ftie_id: ftieList,//['15301', '15974', '14662'],
          opty_name: optyList,
          record_per_page: self.perPage,
          page_index: self.currentPage,
          keywords: self.keywords,
          customization_shipping_pn: customizationShippingPnSelected,
          downloadTime: downloadTime,
          mergedDataframe: self.mergedDataframe
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = 'iventory_report_' + dateTimeStr + '.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });

      },

      // TODO: NEW
      getInventory() {
        let self = this;
        if (self.thisPageLoadingCnt == 0) {
          self.already_first_search_flag = false;
          self.thisPageLoadingCnt = self.thisPageLoadingCnt + 1;
        }
        let url = self.$root.baseUrl + '/inventory-management/unique_component/';
        console.log('####inventory management######');
        let ftieList = [];
        if (self.ftieId !== '') {
          ftieList.push(self.ftieId);
        }

        let partNumberList = [];
        if (self.partNumber !== '') {
          partNumberList.push(self.partNumber);
        }

        let customizationShippingPnSelected = [];
        if (self.customizationPartNumber.length == 0) {
          customizationShippingPnSelected = '';
        } else {
          for (i = 0; i < self.customizationPartNumber.length; i++) {
            customizationShippingPnSelected.push(self.customizationPartNumber[i]['value'])
          }
        }

        let optyList = [];
        if (self.optyName !== '') {
          optyList.push(self.optyName);
        }

        let request_data = {
          part_number: partNumberList,
          ftie_id: ftieList,//['15301', '15974', '14662'],
          opty_name: optyList,
          record_per_page: self.perPage,
          page_index: self.currentPage,
          keywords: self.keywords,
          customization_shipping_pn: customizationShippingPnSelected
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        let searchedDataAll = [];
        let nreTotalCount = 0;
        let mergedDfResult = '';
        if (self.already_first_search_flag == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              searchedData = JSON.parse(res['unique_parts_info_list']);
              searchedDataAll = JSON.parse(res['unique_parts_info_list']);
              mergedDfResult = res['merged_dataframe'];
              nreTotalCount = parseInt(res['total_count']);
              let customizationPnResult = res['shipping_pn_list'];
              let customizationPnSelection = [];
              //console.log(searchedData);
              var i;
              for (i = 0; i < customizationPnResult.length; i++) {
                customizationPnSelection.push({ value: customizationPnResult[i], text: customizationPnResult[i] });
              }

             // REGION: set chosen customizationPartNumber
             // -- set chosen customizationPartNumber by previous searching (select all at first)
              console.log("res['chosen_shipping_pn']::");
              console.log(res['chosen_shipping_pn']);
              if (res['chosen_shipping_pn'] !== null && res['chosen_shipping_pn'].length > 0) {
                var i;
                let customizationPartNumberChosenBefore = [];
                for (i = 0; i < res['chosen_shipping_pn'].length; i++) {
                  customizationPartNumberChosenBefore.push(res['chosen_shipping_pn'][i]);
                }
              }
             //-- set chosen customizationPartNumber by all
              else {
                if (customizationPnSelection !== []) {
                  self.shippingPnSelection = JSON.parse(JSON.stringify(customizationPnSelection));
                } else {
                  self.shippingPnSelection = '';
                  self.customizationPartNumber = '';
                }

              }
              console.log("self.customizationPartNumber::");
              console.log(self.customizationPartNumber);
              // END REGION
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
              self.shippingPnSelection = '';
              self.customizationPartNumber = '';
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              self.shippingPnSelection = '';
              self.customizationPartNumber = '';
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
            self.shippingPnSelection = '';
            self.customizationPartNumber = '';
          })
          .finally(() => {
            self.searching = false;
            self.already_first_search_flag = true;
            if (self.already_first_search_flag == true) {
              eventHub.$emit('loading', false);
            }
            self.searchedData = searchedData;
            self.searchedDataAll = searchedDataAll;
            self.nreTotalCount = nreTotalCount;
            self.mergedDataframe = mergedDfResult;
            // REGION:: TODO: REBUILD LIST BY PAGE
            self.buildDataIndexbyPage();
            // END REGION:: TODO: REBUILD LIST BY PAGE
          })
      },

      resetFilterCondition() {
        let self = this;
        self.keywords = '';
        self.ftieId = '';
        self.optyName = '';
        self.partNumber = '';
        self.shippingPnSelection = '';
        self.customizationPartNumber = '';
        self.customizationPartNumberSingle = '';
        self.date_from = '';
      },
      buildDataIndexbyPage() {
        let self = this;
        if (self.searchedDataAll && self.searchedDataAll.length > 0 && self.nreTotalCount !== null && self.nreTotalCount > 0) {
          let startIndex = (self.currentPage - 1) * self.perPage;
          if (startIndex < self.nreTotalCount - 1) {
            let endIndex = (startIndex + self.perPage);
            if (endIndex > self.nreTotalCount) {
              endIndex = self.nreTotalCount;
            }
            self.searchedData = _.slice(self.searchedDataAll, startIndex, endIndex);
          }
        }
      }
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CustomLevelReport.vue